import { render, staticRenderFns } from "./WindfarmPage.vue?vue&type=template&id=fcb3560a&"
import script from "./WindfarmPage.vue?vue&type=script&lang=js&"
export * from "./WindfarmPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports